import { configureStore as toolkitConfigureStore } from '@reduxjs/toolkit';
import { Store } from 'redux';

import api from 'src/api/rtk/rtk-api';

import rootReducer from './rootReducer';
import { RootState } from './types';

export default function configureStore(): Store<RootState> {
  if (process.env.NODE_ENV === 'development') {
    // Push development middlewares here...
  }

  const middlewares = [api.middleware];

  const store = toolkitConfigureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }).concat(middlewares),
    devTools: process.env.NODE_ENV !== 'production',
  });

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept(() => {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
